export default "__VITE_ASSET__Bc71Hki4__"